<div class="container__header" data-testid="page-header">
    <h1>{{ headline }}</h1>
    <div *ngIf="subline" class="container__subline">{{ subline }}</div>

    <div *ngIf="hasButton" class="margin-top--base">
        <ng-content select="[button-slot]"></ng-content>
    </div>
</div>
